import { render, staticRenderFns } from "./ManageDetail.vue?vue&type=template&id=1031a76d&scoped=true"
import script from "./ManageDetail.vue?vue&type=script&lang=js"
export * from "./ManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031a76d",
  null
  
)

export default component.exports